import MobileLayout from './Mobile/DueDateFieldLayout.mobile';
import WebLayout from './Web/DueDateFieldLayout.web';
import { isReactNative } from 'ui-builder';

export * from './types'

export default isReactNative() ? MobileLayout : WebLayout;

